module.exports = __webpack_public_path__ + "static/profil-448_optimized-bf5b7aab7a8c0d917e71667f8f3a96f1.jpg";